export default "__VITE_ASSET__1202744e__"